"use client";

import { tsv } from "@faire/slate/lib/tsv";
import { useFloatingContext } from "@faire/slate/private/floating/FloatingContext";
import { useMergeRefs } from "@floating-ui/react";
import React, { useRef } from "react";

import { MODAL_TITLE_ID } from "./consts";
import { useModalContext } from "./ModalContext";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  ref?: React.Ref<HTMLDivElement>;
}

export const ModalBase: React.FC<IProps> = ({
  children,
  className,
  ref: refProp,
  ...props
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const { open, propGetters, refs } = useFloatingContext();
  const { animating, modalWidth } = useModalContext();
  const mergedRef = useMergeRefs([refs.setFloating, ref, refProp]);
  const hasAriaLabel = props["aria-labelledby"] || props["aria-label"];

  const floatingProps = propGetters.getFloatingProps({
    ...props,
    ref: mergedRef,
    className: modalStyle.cls({ width: modalWidth, className }),
    ...(hasAriaLabel ? {} : { "aria-labelledby": MODAL_TITLE_ID }),
  });

  return (
    <div data-animating={animating} data-open={open} {...floatingProps}>
      {children}
    </div>
  );
};

const modalStyle = tsv({
  base: "fs-modal",
  variants: {
    width: {
      small: "",
      medium: "fs-modal--medium",
      large: "fs-modal--large",
      xlarge: "fs-modal--xlarge",
      custom: "",
    },
  },
});
